import classNames from 'classnames';
import SCREEN_SIZES from 'constants/screen-sizes';
import useWindowSize from 'hooks/useWindowSize';
import { useLocation } from 'react-router-dom';
import useGetDomainTracking from 'store/services/helperHooks/useGetDomainTracking';
import useIsLimitedUser from 'store/services/helperHooks/useIsLimitedUser';
import { getHeaderMode } from 'utils/getCustomersMode';
import CreationFlowNavigationButtons from './partials/CreationFlowNavigationButtons';
import HeaderActions from './partials/HeaderActions';
import Logo from './partials/Logo';
import MainItems from './partials/MainItems';
import HeaderWrapper from './style/HeaderWrapper';

const Header = () => {
  const isLimitedUser = useIsLimitedUser();
  const { innerWidth } = useWindowSize();
  const { pathname } = useLocation();

  const { data } = useGetDomainTracking();
  const mode = getHeaderMode(data?.key);

  const entityCreateCase = pathname.includes('create');
  const surveyPage = pathname.includes('survey');

  return (
    <HeaderWrapper
      className={classNames(
        { 'dark-mode': mode === 'dark' },
        'd-flex align-items-center justify-content-between ph--32'
      )}
    >
      <div className='d-flex justify-content-start align-items-center'>
        <Logo isLimitedUser={isLimitedUser} />
        {SCREEN_SIZES.XL < innerWidth && <MainItems />}
      </div>
      {entityCreateCase && !surveyPage ? <CreationFlowNavigationButtons /> : <HeaderActions />}
    </HeaderWrapper>
  );
};

export default Header;
